import AxiosClient from "../Network/AxiosClient";

const _checkTokenExpiry = () => {
  AxiosClient.get(`${process.env.REACT_APP_API_URL}/api/users/api/v1/details`, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
    },
  })
    .then((res) => {
      console.log("Token valid");
    })
    .catch((err) => console.log("Error"));
};

export default _checkTokenExpiry;
